import React, { useState } from 'react';
import PropTypes from 'prop-types';

/** CDN service icon; renders null for an unknown service or a failed load. Not for Material Symbols. */
export const ServiceIcon = React.memo(({ service, size = 'medium', className = '' }) => {
    // Track WHICH service failed, so switching to another one un-hides the icon —
    // hiding the node via style.display left it hidden forever after a reuse.
    const [failedService, setFailedService] = useState(null);

    // Only homarr-labs CDN services (NO Material Symbols like email)
    const iconMap = {
        discord: 'https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/svg/discord.svg',
        notifiarr: 'https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/svg/notifiarr.svg',
        radarr: 'https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/svg/radarr.svg',
        sonarr: 'https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/svg/sonarr.svg',
        lidarr: 'https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/svg/lidarr.svg',
        plex: 'https://cdn.jsdelivr.net/gh/homarr-labs/dashboard-icons/svg/plex.svg',
    };

    // Size mapping (pixel values for consistent sizing)
    const sizeMap = {
        small: '20px',
        medium: '24px',
        large: '32px',
        xlarge: '48px',
    };

    const normalizedService = service?.toLowerCase();
    const iconUrl = iconMap[normalizedService];
    const iconSize = sizeMap[size] || sizeMap.medium;

    // Return null for unknown services
    if (!iconUrl) {
        console.warn(`ServiceIcon: Unknown service "${service}"`);
        return null;
    }

    if (failedService === normalizedService) return null;

    // Render SVG from CDN
    return (
        <img
            src={iconUrl}
            alt={`${service} icon`}
            style={{ width: iconSize, height: iconSize }}
            className={`inline-block ${className}`}
            onError={() => {
                console.warn(`Failed to load icon for ${service}`);
                setFailedService(normalizedService);
            }}
        />
    );
});

ServiceIcon.displayName = 'ServiceIcon';

ServiceIcon.propTypes = {
    service: PropTypes.oneOf(['discord', 'notifiarr', 'radarr', 'sonarr', 'lidarr', 'plex'])
        .isRequired,
    size: PropTypes.oneOf(['small', 'medium', 'large', 'xlarge']),
    className: PropTypes.string,
};
